import React from "react";

class Person extends React.Component {
  render() {
    return (
      <div>
        {this.props.biography && (
          <div className="rounded cursor-default border-b-2 shadow p-4 mb-4">
            <div className="font-bold mb-2">Biography</div>
            <p className="text-grey-dark text-grey-darker tracking-normal text-justify text-base whitespace-pre-line">
              {this.props.biography}
            </p>
          </div>
        )}
      </div>
    );
  }
}

export default Person;



// WEBPACK FOOTER //
// ./src/components/Media/Person.js